import React from 'react';
import './SplashScreen.css';

const SplashScreen = () => {
  return (
    <div className="splash-wrapper">
      {/* Background Floating Candles for depth */}
      <div className="candles-bg-overlay">
        <div className="bg-candle c1"></div>
        <div className="bg-candle c2"></div>
        <div className="bg-candle c3"></div>
        <div className="bg-candle c4"></div>
      </div>

      <div className="splash-main-container">
        {/* Central Logo with Glow */}
        <div className="trade-house-logo-premium">
          <span className="logo-text-premium">TFH</span>
          <div className="logo-pulse"></div>
        </div>
        
        {/* Brand Identity */}
        <div className="text-section-premium">
          <h1 className="brand-name-premium">Trading Flow Hub</h1>
          <p className="brand-motto-premium">Live the Market, Trade the Future</p>
        </div>

        {/* Realistic Candle Wave Loader */}
        <div className="trading-candles-loader-pro">
          <div className="candle-pro green p1"></div>
          <div className="candle-pro red p2"></div>
          <div className="candle-pro green p3"></div>
          <div className="candle-pro red p4"></div>
          <div className="candle-pro green p5"></div>
        </div>
      </div>

      <div className="splash-footer-premium">
        <span>EST. 2026 • GLOBAL TRADING NODE</span>
      </div>
    </div>
  );
};

export default SplashScreen;